class UsersViewReactTranslations {
    static $inject = ['name', 'channel', 'testUsers', 'lastInteraction', 'tooltip'];
    constructor(name, channel, testUsers, lastInteraction, tooltip) {
        this.nameLabel = name;
        this.channelLabel = channel;
        this.testUsersLabel = testUsers;
        this.lastInteractionLabel = lastInteraction;
        this.tooltipOpenInNewTabLabel = tooltip;
    }
}
export default UsersViewReactTranslations;
